var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mt-10 mb-0 grey--text",staticStyle:{"justify-self":"center"}},[_vm._v("Check out these titles!")]),_c('MovieCarousel2')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }